import React from 'react'
import { useState } from 'hooks'

import StyledHelp, { StyledQuestion } from './StyledHelp'
import ContactForm from './ContactForm'

const Question = ({ title, content }) => {
  const [active, toggleActive] = useState(false)

  return (
    <StyledQuestion className={active ? 'active' : null}>
      <h3 className="help-title" onClick={() => toggleActive(!active)} dangerouslySetInnerHTML={{ __html: title }} />
      <ul className="help-content" dangerouslySetInnerHTML={{ __html: content }} />
    </StyledQuestion>
  )
}

const parseQuestions = html =>
  html
    .split('<h4>')
    .map(e => e && e.match(/(.*)<\/h4>.*?<ul[^>]*>(.*)<\/ul>/s))
    .filter(e => e)
    .map(([, title, content]) => ({ title, content }))

const Help = ({ content }) => (
  <StyledHelp>
    <div className="questions">
      {parseQuestions(content || '').map((props, i) => (
        <Question {...props} key={i} />
      ))}
    </div>
    <ContactForm />
  </StyledHelp>
)

export default Help
